import type { TValuesTimeseriesPoints } from 'App/Map/types'
import { DropdownSelectorPoint } from '../DropdownSelectorPoint/DropdownSelectorPoint'
import { DropdownSelectorProperty } from '../DropdownSelectorProperty/DropdownSelectorProperty'

export const WindMachineDropdown = ({
  isPoint = true,
  valuesTimeseriesToFilterOn,
}: {
  isPoint?: boolean
  valuesTimeseriesToFilterOn?: TValuesTimeseriesPoints[]
}) => {
  return isPoint ? (
    <DropdownSelectorPoint
      valuesTimeseriesToFilterOn={valuesTimeseriesToFilterOn}
      pointCategory="windMachinePoint"
    />
  ) : (
    <DropdownSelectorProperty
      valuesTimeseriesToFilterOn={[]}
      propertyPermissionsToCheck={['VIEW_CONTROLLABLE_FROST_FAN_DETAILS']}
    />
  )
}
